<template>
    <v-row>
        <v-col v-for="field in fields" :key="field.name" cols="12" md="4">
            <v-select
                v-if="field.name === 'country_iso_code'"
                :value="value[field.name]"
                :items="countryIsoCodes"
                :label="field.label"
                :rules="rulesFor(field)"
                :disabled="disabled"
                required
                class="required"
                outlined
                dense
                hide-details="auto"
                @input="updateField(field.name, $event)"
            />
            <v-text-field
                v-else
                :value="value[field.name]"
                :label="field.label"
                :rules="rulesFor(field)"
                :maxlength="field.maxLength"
                :type="field.type || 'text'"
                :disabled="disabled"
                outlined
                dense
                hide-details="auto"
                @input="updateField(field.name, $event)"
            />
        </v-col>
    </v-row>
</template>

<script>
import {email} from 'vuelidate/lib/validators';
import {countries} from '@/enum/countries';

export default {
    name: 'RecipientAddressFields',
    props: {
        value: {type: Object, required: true},
        disabled: {type: Boolean, default: false}
    },
    computed: {
        fields() {
            return [
                {name: 'street', maxLength: 100},
                {name: 'house_number', maxLength: 16},
                {name: 'suburb', maxLength: 100},
                {name: 'city', maxLength: 50},
                {name: 'postal_code', maxLength: 8},
                {name: 'country', maxLength: 30},
                {name: 'country_iso_code', maxLength: 2},
                {name: 'phone', maxLength: 20, type: 'tel'},
                {name: 'email', maxLength: 50, type: 'email'}
            ].map(field => ({...field, label: this.$t('address.' + field.name)}));
        },
        countryIsoCodes() {
            return countries.map(country => ({
                value: country.code,
                text: country.name + ' (' + country.code + ')'
            }));
        }
    },
    methods: {
        updateField(name, value) {
            this.$emit('input', {...this.value, [name]: value});
        },
        rulesFor(field) {
            const rules = [value => !value || String(value).length <= field.maxLength
                || this.$t('recipient_dialog.max_length', {max: field.maxLength})];
            if (field.name === 'country_iso_code') {
                rules.push(value => Boolean(value) || this.$t('validation.country_iso_code.required'));
            }
            if (field.name === 'email') {
                rules.push(value => email(value) || this.$t('validation.email.email'));
            }
            return rules;
        }
    }
};
</script>
